import styled from "styled-components";

export const HiddenScrollBox = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${(p) => p.theme.spacing[8]}px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DottedGridPanel = styled.div`
  width: 35%;
  min-width: 260px;
  background: radial-gradient(
      circle,
      ${(p) => p.theme.colors.surface.border.gray.subtle} 1px,
      transparent 1px
    ),
    ${(p) => p.theme.colors.surface.background.gray.moderate};
  background-size: 20px 20px, auto;
  border-left: 1px solid ${(p) => p.theme.colors.surface.border.gray.subtle};
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${(p) => p.theme.spacing[7]}px;
`;